import script from "./CoverImgBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./CoverImgBackground.vue?vue&type=script&setup=true&lang=js"

import "./CoverImgBackground.vue?vue&type=style&index=0&id=73ce6ce1&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73ce6ce1"]])

export default __exports__